export const mockData = {
    credits: {
      teachers: 1250,
      students: 3750,
      total: 5000
    },
    byExtension: {
      teachers: {
        Whiteboard: { total: 400, SpinWheel: 150, MagicACVBar: 200, Diagrams: 50 },
        Booking: { total: 300, AskBuddy: 200, Recommended: 100 },
        Assignments: { total: 250, AutoGrade: 150, Suggestions: 100 },
        Events: { total: 200, BulkEvents: 150, SingleEvent: 50 },
        Feedback: { total: 100, Poll: 40, Text: 30, Audio: 20, Video: 10 }
      },
      students: {
        Whiteboard: { total: 1200, SpinWheel: 500, MagicACVBar: 600, Diagrams: 100 },
        Booking: { total: 1000, AskBuddy: 700, Recommended: 300 },
        Assignments: { total: 800, AutoGrade: 500, Suggestions: 300 },
        Events: { total: 500, BulkEvents: 300, SingleEvent: 200 },
        Feedback: { total: 250, Poll: 100, Text: 80, Audio: 50, Video: 20 }
      }
    },
    byUser: [
      { id: 1, name: "Prof. Smith", role: "teacher", Whiteboard: 150, Booking: 100, Assignments: 80, Events: 50, Feedback: 20 },
      { id: 2, name: "Prof. Johnson", role: "teacher", Whiteboard: 120, Booking: 90, Assignments: 70, Events: 60, Feedback: 30 },
      { id: 3, name: "Prof. Williams", role: "teacher", Whiteboard: 130, Booking: 110, Assignments: 100, Events: 90, Feedback: 50 },
      { id: 4, name: "Student A", role: "student", Whiteboard: 200, Booking: 150, Assignments: 120, Events: 80, Feedback: 40 },
      { id: 5, name: "Student B", role: "student", Whiteboard: 180, Booking: 140, Assignments: 110, Events: 70, Feedback: 30 },
      { id: 6, name: "Student C", role: "student", Whiteboard: 220, Booking: 160, Assignments: 130, Events: 90, Feedback: 50 },
      { id: 7, name: "Student D", role: "student", Whiteboard: 190, Booking: 130, Assignments: 100, Events: 60, Feedback: 20 },
      { id: 8, name: "Student E", role: "student", Whiteboard: 210, Booking: 170, Assignments: 140, Events: 100, Feedback: 60 },
      { id: 9, name: "Student F", role: "student", Whiteboard: 170, Booking: 120, Assignments: 90, Events: 50, Feedback: 10 },
      { id: 10, name: "Student G", role: "student", Whiteboard: 230, Booking: 180, Assignments: 150, Events: 110, Feedback: 70 }
    ],
    advisorTips: [
      "Prioritize using AI for repetitive tasks like grading to save time",
      "Encourage students to use the 'Recommended' feature in Booking for optimal scheduling",
      "Use bulk operations in Events to reduce credit consumption",
      "The Magic ACV Bar in Whiteboard consumes more credits - use it judiciously",
      "Audio and Video feedback consume more credits than text - consider alternatives"
    ]
  };